import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../Common/Button';
import { hideUpdateInfo } from './MyInfo';

const ExternalMandate: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <div className="mandate">
      <div className="accordion-padding">
        <h3>{t('myInfo:customerInfo.authorizations')}</h3>
        <p>{t('myInfo:mandate.externalDefinePeople')}</p>
        <Button link={`${import.meta.env.VITE_IAM_MANDATE}`} disabled={hideUpdateInfo}>{t('myInfo:mandate.authorizeUser')}</Button>
      </div>
    </div>
  );
};

export default ExternalMandate;
